import { SERVER_URL } from '../utils/apiUtilsConstants';

let _token = null;
let _expiresAt = 0;
let _loggingEnabled = false;

export async function fetchLogToken() {
  try {
    const res = await fetch(`${SERVER_URL}/api/log/token`, {
      method: 'POST',
      credentials: 'include',
    });
    if (!res.ok) return;
    const { token, expiresIn, loggingEnabled } = await res.json();

    if (loggingEnabled === false) {
      _token = null;
      _expiresAt = 0;
      _loggingEnabled = false;
      return;
    }

    _token = token;
    _loggingEnabled = true;
    _expiresAt = Date.now() + (expiresIn - 120) * 1000;
  } catch {
    // not authenticated or network error — log silently dropped
  }
}

export function getLogToken() {
  return _token;
}

export function isLoggingEnabled() {
  return _loggingEnabled;
}

export function clearLogToken() {
  _token = null;
  _expiresAt = 0;
}

export function isTokenNearExpiry() {
  return Date.now() > _expiresAt;
}